import styled from "styled-components";
import { thumbHeight } from "./ThumbStyle";
import isPropValid from "@emotion/is-prop-valid";
export const TrackBackground = styled.div.withConfig({
    shouldForwardProp: isPropValid,
}) `
  display: flex;
  align-items: center;
  flex-direction: row;
  // arranges the StepMarks
  justify-content: space-between;
  border-radius: 25px;
  box-sizing: border-box;
  height: ${thumbHeight}px;
  width: 100%;
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVHJhY2tCYWNrZ3JvdW5kLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvU2xpZGVyL3N0eWxlZC9UcmFja0JhY2tncm91bmQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxNQUFNLE1BQU0sbUJBQW1CLENBQUM7QUFDdkMsT0FBTyxFQUFFLFdBQVcsRUFBRSxNQUFNLGNBQWMsQ0FBQztBQUMzQyxPQUFPLFdBQVcsTUFBTSx3QkFBd0IsQ0FBQztBQUVqRCxNQUFNLENBQUMsTUFBTSxlQUFlLEdBQUcsTUFBTSxDQUFDLEdBQUcsQ0FBQyxVQUFVLENBQUM7SUFDbkQsaUJBQWlCLEVBQUUsV0FBVztDQUMvQixDQUFDLENBQUE7Ozs7Ozs7O1lBUVUsV0FBVzs7Q0FFdEIsQ0FBQyJ9